.DiceFace {
  width: 1em;
  height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
  padding: 0.1em;
  box-shadow: inset 0 0.05em white, inset 0 -0.05em #bbb, inset 0.05em 0 #d7d7d7, inset -0.05em 0 #d7d7d7;
  border-radius: 10%;
  transform-origin: center;
  background-color: #e7e7e7;
  font-family: var(--base-font);
}
.DiceFace[element=fire] {
  background-color: #d54b33;
}
.DiceFace[element=earth] {
  background-color: #62C370;
}
.DiceFace[element=water] {
  background-color: #639bff;
}
.DiceFace .Icon {
  width: 95%;
  height: 95%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  image-rendering: smooth;
}
.DiceFace .Icon path {
  width: 100%;
  height: 100%;
}
.DiceFace .SmallNumeral {
  font-size: 0.5em;
  line-height: 1em;
  position: absolute;
  bottom: 0.05em;
  right: 0.2em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.DiceFace .Pips {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas: "a . c" "e g f" "d . b";
  grid-template-rows: repeat(3, 1fr);
  grid-template-columns: repeat(3, 1fr);
}
.DiceFace .Pips .Pip {
  width: 0.15em;
  height: 0.15em;
  display: block;
  align-self: center;
  justify-self: center;
  border-radius: 100%;
  background-color: black;
}
.DiceFace .Pips .Pip:nth-child(1) {
  grid-area: a;
}
.DiceFace .Pips .Pip:nth-child(2) {
  grid-area: b;
}
.DiceFace .Pips .Pip:nth-child(3) {
  grid-area: c;
}
.DiceFace .Pips .Pip:nth-child(4) {
  grid-area: d;
}
.DiceFace .Pips .Pip:nth-child(5) {
  grid-area: e;
}
.DiceFace .Pips .Pip:nth-child(6) {
  grid-area: f;
}
.DiceFace .Pips .Pip:nth-child(odd):last-child {
  grid-area: g;
}
